<template>
  <div>
    <v-stepper vertical v-model="step" class="px-md-10 px-0">

      <v-stepper-step step="1">
        مرحله ۱
        <small>نوع سفارش</small>
      </v-stepper-step>
      <v-stepper-content step="1" class="mx-0 px-1 pr-2">
        <h5 class="pb-5 text-center"> {{ pageTitle }}</h5>
        <div class="m-3 px-0 mx-0">
          <v-text-field outlined
                        dense
                        v-model="data.organizationName"
                        hint="لطفا نام مجموعه خود را وارد کنید."
                        maxLength="50"
                        counter="50"
                        :rules="this.$rules.requiredString"
                        label="نام مجموعه "
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3 px-0 mx-0">
          <v-text-field outlined
                        dense
                        v-model="data.brandName"
                        hint="لطفا نام برند خود را  وارد  کنید."
                        maxLength="50"
                        counter="50"
                        :rules="this.$rules.requiredString"
                        label="نام برند "
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3 px-0 mx-0">
          <v-text-field outlined
                        v-model="data.brandSlogan"
                        dense
                        hint="لطفا شعار برند خود را وارد نمایید"
                        placeholder="لطفا شعار برند خود را وارد نمایید"
                        maxLength="50"
                        counter="50"
                        label="شعار برند"
                        append-icon="mdi-domain"/>
        </div>
        <div class="m-3 px-0 mx-0">
          <v-switch
              class="text-right"
              v-model="data.slogan"
              dense
              label="میخواهم شعار در سربرگ اضافه شود"
          ></v-switch>
        </div>
        <v-btn class="submit-btn" @click="step1Validate">
          ادامه
          <span class="fa fa-arrow-left mr-1"></span>
        </v-btn>
      </v-stepper-content>

      <v-stepper-step step="2">
        مرحله ۲
        <small>اطلاعات اولیه سفارش</small>
      </v-stepper-step>
      <v-stepper-content step="2" class="mx-0 px-1 pr-2">
        <div class="mt-2">
          <div>
            <v-expansion-panels class="px-1">

              <v-expansion-panel
                  class="mb-4 px-1 customStyle"
                  v-if="data.type==='office_set' || data.type==='header' "
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">

                  {{
                    data.type === 'header' ? ' لطفا زبان طراحی سربرگ خود را انتخاب نمایید.' : '  لطفا زبان طراحی ست اداری را انتخاب نمایید.'
                  }}
                  <div v-if="data.logoLanguage && !isMobile">
                    <v-chip
                        v-if="data.logoLanguage"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["langType"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.logoLanguage && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <lang-type @persianName="persianName" v-model="data.logoLanguage" class="mb-4"
                             v-if="data.type==='header' "></lang-type>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel class="mb-4 customStyle"
                                 v-if="data.type==='office_set' || data.type==='header'">
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  {{
                    data.type === 'header' ? '  لطفا رنگ سربرگ خود را انتخاب نمایید.' : '  لطفا رنگ  ست اداری را انتخاب نمایید'
                  }}
                  <div v-if="data.color.length>0 && !isMobile">
                    <v-chip
                        v-if="data.color.length>0"
                        v-for="color in data.color"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        :color="color"
                        class="mx-2"
                        outlined
                    >{{ color }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.color.length>0 && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <color-pickers count="3" v-model="data.color" class="mb-4"
                                 v-if="data.type==='office_set' || data.type==='header'"></color-pickers>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                  class="mb-4 customStyle"
                  v-if="data.type === 'header' || data.type==='office_set'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع سفارش خودرا انتخاب کنید.

                  <div class="row mr-2" v-if="!isMobile">
                    <div v-if="data.orderType">
                      <v-chip
                          v-if="data.orderType"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ orderType.find((x) => x.value === data.orderType).text }}
                      </v-chip>
                    </div>
                    <div v-if="data.orderType==='designPrint' && data.printCount">
                      <v-chip
                          v-if="data.printCount"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ data.printCount|currency|persianNum }} عدد
                      </v-chip>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.orderType && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-0">
                  <v-autocomplete
                      v-if="data.type==='header'"
                      class="mx-0 my-1"
                      v-model="data.orderType"
                      :items="orderType"
                      dense
                      item-text="text"
                      item-value="value"
                      label="نوع سفارش"
                      placeholder="لطفا یک گزینه را انتخاب نمایید."
                      hint="لطفا یک گزینه را انتخاب نمایید."
                      outlined
                  ></v-autocomplete>
                  <v-text-field
                      v-if="data.orderType==='designPrint'"
                      class="m-1"
                      v-model="printCounting"
                      dense
                      item-text="text"
                      @keypress="allowOnlyNumbers"
                      item-value="value"
                      label="تعداد چاپ"
                      placeholder="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                      hint="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                      outlined
                  ></v-text-field>
                  <v-autocomplete
                      v-if="data.type==='visit_card'"
                      class="m-1"
                      :items="printType"
                      dense
                      item-text="text"
                      item-value="value"
                      label="نوع طرح"
                      placeholder="لطفا یک گزینه را انتخاب نمایید."
                      hint="لطفا یک گزینه را انتخاب نمایید."
                      outlined
                  ></v-autocomplete>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                  class="mb-4 customStyle"
                  v-if="data.type==='header' || data.type==='office_set'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا سایز سربرگ خود را انتخاب نمایید.
                  <div class="row mr-2" v-if="!isMobile">
                    <div v-if="data.size.length>0">
                      <v-chip
                          v-if="data.size"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ data.size.toString() }}
                      </v-chip>
                    </div>
                    <div v-if="data.orientation">
                      <v-chip
                          v-if="data.orientation"
                          close-icon="mdi-close-outline"
                          color="indigo"
                          small
                          class="mx-2"
                          outlined
                      >{{ data.orientation === 'horizontal' ? 'افقی' : 'عمودی' }}
                      </v-chip>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.size.length>0 && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-autocomplete
                      v-if="data.type==='header'"
                      class="m-1"
                      v-model="data.size"
                      :items="headerSize"
                      dense
                      item-text="text"
                      multiple
                      item-value="value"
                      label="سایز سربرگ"
                      placeholder="لطفا یک گزینه را انتخاب نمایید."
                      hint="لطفا یک گزینه را انتخاب نمایید."
                      outlined
                  ></v-autocomplete>
                  <v-radio-group class="mt-0 pt-0 px-0 mx-0" row v-model="data.orientation">
                    <v-radio
                        value="vertical"
                    >
                      <template v-slot:label>
                        <img src='@/assets/double-arrow-vertical-symbol.png' class="" width="20"
                             alt="">
                        <span>عمودی</span>
                      </template>
                    </v-radio>
                    <v-radio
                        label="افقی"
                        value="horizontal"
                        class="my-2"
                    >
                      <template v-slot:label>
                        <img src='@/assets/double-arrow-horizontal-symbol.png' width="20"
                             class="ml-2" alt="">
                        <span>افقی</span>
                      </template>
                    </v-radio>


                  </v-radio-group>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                  class="mb-4 customStyle"
                  v-if="data.type==='office_set'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا سایز بروشور خود را انتخاب نمایید.
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <brochure class="mb-4" v-if="data.type==='office_set'"></brochure>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                  class="mb-4 customStyle"
                  v-if="data.type==='header'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا سبک طراحی سربرگ خودرا مشخص نمایید.
                  <div v-if="data.simpleness && !isMobile">
                    <v-chip
                        v-if="data.simpleness"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["headerDesign"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.simpleness && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <header-design @persianName="persianName" class="mb-4" v-model="data.simpleness"
                                 v-if="data.type==='header'"></header-design>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                  class="mb-4 customStyle"
                  v-if="data.type==='visit_card'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع کارت ویزیت خود را مشخص نمایید.
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <card-type class="mb-4" v-if="data.type==='visit_card'"></card-type>

                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                  class="mb-4 customStyle"
                  v-if="data.type==='header'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع طراحی سربرگ خود را مشخص نمایید.
                  <div v-if="data.complexity && !isMobile">
                    <v-chip
                        v-if="data.complexity"
                        close-icon="mdi-close-outline"
                        color="indigo"
                        small
                        class="mx-2"
                        outlined
                    >{{ names["headerDesignType"] }}
                    </v-chip>
                  </div>
                  <template v-slot:actions>
                    <v-icon v-if="data.complexity && isMobile" color="teal">mdi-check</v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <header-design-type @persianName="persianName" class="mb-4"
                                      v-model="data.complexity"
                                      v-if="data.type==='header'"></header-design-type>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel
                  class="mb-4 customStyle"
                  v-if="data.type==='visit_card'"
              >
                <v-expansion-panel-header disable-icon-rotate class="px-1">
                  لطفا نوع طراحی کارت ویزیت خود را مشخص نمایید.
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <design-paint class="mb-4" v-if="data.type==='visit_card'"></design-paint>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
          </div>

        </div>
        <div class="row justify-content-between py-2 mx-auto">
          <v-btn class="submit-btn col-md-1 col-3" @click="step2Validate">
            ادامه
            <span class="fa fa-arrow-left mr-1"></span>
          </v-btn>
          <v-btn class="mx-4 btn-refund col-md-1 col-3 mr-auto" @click="step = 1">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-step step="3">
        مرحله ۳
        <small>مشخصات سایت</small>
      </v-stepper-step>
      <v-stepper-content step="3" class="mx-0 px-1 pr-2">
        <div class="mt-2" v-if="step===3">
          <programming-select class="mt-5" v-if="data.type==='logo'"
                              v-model="data.programming_language"></programming-select>
          <div v-if="data.type==='header'" class="">
            <span class="text-center pb-2">لطفا یک یا چند سربرگ مورد علاقه خود را برای ما ارسال کنید. تا تیم طراحی ما نیاز شما را بهتر درک کنند</span>
          </div>
          <div class="" v-if="data.type==='visit_card'">
            <span class="text-center pb-2">لطفا عکس یک یا چند کارت ویزیت مورد علاقه خود را برای ما ارسال کنید. تا تیم طراحی ما نیاز شما را بهتر درک کنند.</span>
          </div>
          <v-file-input
              v-model="data.file"
              label=" بارگذاری عکس "
              outlined
              accept="image/png, image/jpeg,image/jpg, image/bmp"
              placeholder="عکس موردنظر خود را بارگذاری کنید."
              hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
              prepend-inner-icon="mdi-camera"
              clearable
              small-chips
              clear-icon="mdi-close-circle-outline"
              prepend-icon=""
              dense
              multiple
              class="mt-1 pt-1"
          >
          </v-file-input>
        </div>
        <div class="row justify-content-between py-2 mx-auto">
          <v-btn class="submit-btn  col-md-1 col-3" @click="step=4">
            ادامه
            <span class="fa fa-arrow-left mr-1"></span>
          </v-btn>
          <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 2">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-step step="4">
        مرحله ۴
        <small>زمان تحویل</small>
      </v-stepper-step>
      <v-stepper-content step="4" class="mx-0 px-1 pr-2">
        <div class="m-3 px-0 mx-0" v-if="data.type==='header'">
          <span class="text-center pb-2">لطفا لوگو برند خودرابارگذاری کنید</span>
        </div>
        <v-file-input
            v-if="data.type==='header'"
            v-model="data.brandLogo"
            label=" بارگذاری عکس "
            outlined
            accept="image/png,image/jpeg"
            placeholder="لطفا لوگو برند خودرابارگذاری کنید."
            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
            prepend-inner-icon="mdi-camera"
            clearable
            small-chips
            multiple
            clear-icon="mdi-close-circle-outline"
            prepend-icon=""
            dense
            class="mt-1 mx-3 pt-1"
        >
        </v-file-input>
        <div class="mx-3">
          <date-picker
              v-model="data.deliveryTime"
              color="#00acc1"
              label="زمان تحویل"
              input-class="mb-0 rounded"
              persianDigits
              clearable
              :timezone="false"
              format="YYYY-MM-DD"
              style="font-size: 13px!important"
              class="dateSet"
              display-format="jMMMM jD"
              :min="countDay"
          />
        </div>
        <div class="m-3 px-0 mx-0" v-if="data.type==='header'">
          <p class="mt-10 pb-2">لطفا متون ومندرجات سربرگ خود را تایپ کنید.</p>
          <V8Editor v-model="data.headerTexts"/>
        </div>
        <div class="m-3 px-0 mx-0" v-if="data.type==='header'">
          <v-text-field outlined
                        dense
                        class="pt-8"
                        v-model="data.businessDescription"
                        hint="لطفا درمورد حوزه کسب وکارخود توضیح دهید."
                        maxLength="50"
                        counter="50"
                        :rules="this.$rules.requiredString"
                        label="حوزه کسب وکار "
                        append-icon="mdi-domain"/>
        </div>
        <div class="row justify-content-between py-2 mx-auto">
          <v-btn class="submit-btn mt-5 col-md-1 col-3" @click="step3Validate">
            <span class="fa fa-arrow-left mr-1"></span>
            ادامه
          </v-btn>
          <v-btn class="mx-4 mt-5 col-md-1 col-3 btn-refund" @click="step = 3">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-step step="5">
        مرحله ۵
        <small>توضیحات</small>
      </v-stepper-step>
      <v-stepper-content step="5" class="mx-0 px-1 pr-2">
        <div class="mt-1">
          <div class="mb-2">
            <span class="text-center pb-2">لطفا توضیحات تکمیلی خود در مورد نیازتان را برای متخصصان ما یادداشت نمایید، تا بتوانیم به بهترین شکل ممکن درخواست شما را بررسی و پاسخ دهیم.</span>
          </div>
          <V8Editor class="mt-3" v-model="data.description"/>

        </div>

        <div class="row justify-content-between py-2 mx-auto">
          <v-btn :loading="loading" class="submit-btn col-md-1 col-4 mt-5" @click="submit">
            <span class="fa fa-save mr-1"></span>
            ثبت سفارش
          </v-btn>
          <v-btn class="mx-4 mt-5 btn-refund col-md-1 col-4" @click="step = 4">
            <span class="fa fa-arrow-right mr-1"></span>
            بازگشت
          </v-btn>
        </div>
      </v-stepper-content>

    </v-stepper>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "../../../../core/plugins/CKEditorUploadFileAdapter";
import LogoType from "../../components/logoType";
import LangType from "../../components/langType";
import Properties from "../../components/properties";
import SabkType from "../../components/sabkType";
import ColorPickers from "../../components/colorPickers";
import CardType from "../../components/cardType";
import DesignType from "../../components/designType";
import DesignPaint from "../../components/designPaint";
import ComplicativeType from "../../components/complicativeType";
import ShapeType from "../../components/shapeType";
import HeaderSize from "../../components/headerSize";
import HeaderDesign from "../../components/headerDesign";
import HeaderDesignType from "../../components/headerDesignType";
import HeaderShape from "../../components/headerShape";
import Brochure from "../../components/brouchor";
import {createFormData} from "../../../../Utilities/FormRequestHelper";


export default {
  name: "officeStepper",
  components: {
    Brochure,
    HeaderShape,
    HeaderDesignType,
    HeaderDesign,
    HeaderSize,
    ShapeType,
    ComplicativeType,
    DesignPaint, DesignType, CardType, ColorPickers, SabkType, Properties, LangType, LogoType
  },
  data() {
    return {

      step: 1,
      days: '',
      marker: true,
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          language: 'fa',
          contentsLangDirection: 'rtl',
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
      mainPrice: "",
      dialogPayment: false,
      designs: false,
      payDialogInfo: {},
      orderType: [
        {text: 'فقط طراحی', value: 'design'},
        {text: 'طراحی به همراه چاپ', value: 'designPrint'},
      ],
      printType: [
        {text: 'فقط طراحی', value: 'design'},
        {text: 'طراحی به همراه چاپ', value: 'designPrint'},
      ],
      printCount: [
        {text: '۱,۰۰۰ عدد', value: '1000'},
        {text: '۲,۰۰۰ عدد', value: '2000'},
        {text: '۳,۰۰۰ عدد', value: '3000'},
        {text: '۴,۰۰۰ عدد', value: '4000'},
        {text: '۵,۰۰۰ عدد', value: '5000'},
        {text: '۱۰,۰۰۰ عدد', value: '10000'},
      ],
      headerSize: [
        {text: 'A3', value: 'A3'},
        {text: 'A4', value: 'A4'},
        {text: 'A5', value: 'A5'},
        {text: 'A6', value: 'A6'},
        {text: 'B5', value: 'B5'},
      ],
      payableTransaction: null,
      brandSlogan: null,
      selectedRows: [],
      paymentLoading: false,
      data: {
        organizationName: null,
        brandSlogan: null,
        simpleness: null,
        slogan: 0,
        orderType: null,
        printCount: null,
        designStyle: null,
        diagram: null,
        deliveryTime: null,
        complexity: null,
        color: [],
        brandLogo: [],
        businessDescription: '',
        headerTexts: '',
        hasBrandSlogan: false,
        preferredCurrency: 'Rial',
        brandName: null,
        logoLanguage: null,
        size: [],
        orientation: "vertical",
        user_price: '',
        type: null,
        logoType: null,
        site_type: null,
        file: [],
        description: '',
      },
      orderTypes: [
        {key: 'logo', keyAlias: 'طراحی لوگو', icon: '/media/site/aparat.png'},
        {key: 'visit_card', keyAlias: 'طراحی کارت ویزیت', icon: '/media/site/aparat.png'},
        {key: 'office_set', keyAlias: 'طراحی ست اداری', icon: '/media/site/aparat.png'},
        {key: 'header', keyAlias: 'طراحی سربرگ', icon: '/media/site/aparat.png'},
        {key: 'poster', keyAlias: 'طراحی پوستر', icon: '/media/site/aparat.png'},
        {key: 'office_scan', keyAlias: 'طراحی و چاپ اداری', icon: '/media/site/aparat.png'},
      ],
      errors: [],
      dialog: false,
      loading: false,
      rules: [
        v => !!v || 'وارد کردن این فیلد الزامی است'
      ],
      urlRules: [
        (value) => this.isURL(value) || "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
      errorMsg: '',
      nameErr: '',
      pageTitle: '',
      userWallet: [],
      dialogInfo: null,
      tab: null,
      items: [
        'سفارش ها',
        'ثبت سفارش جدید',
      ],
      userInfo: {},
      names: {},
      statusBadge: '',
      userValid: true,
      isRejected: false,
      isPending: false,
      articleDesc: false,
      enterMine: false,
      userInfoGot: false
    }
  },
  methods: {
    persianName(name, field) {
      this.names[field] = name
    },
    isURL(str) {
      var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      if (regex.test(str) || without_regex.test(str)) {
        return true
      } else {
        return false;
      }
    },
    paymentDialog(data) {
      this.payDialogInfo = data
      this.dialogPayment = true
    },
    step1Validate() {
      if (!this.data.organizationName || !this.data.brandName) {
        this.$toast.error('نام برند و نام مجموعه الزامی است.')
        return
      } else if (this.data.hasBrandSlogan && !this.data.brandSlogan) {
        this.$toast.error('شعار برند خودرا بنویسید.');
        return
      } else if (this.data.slogan && !this.data.brandSlogan) {
        this.$toast.error('لطفا شعار برند خودرا وارد کنید.')
      } else
        this.step = 2
    },
    step2Validate() {
      if (this.data.type === 'header') {
        const header = [
          {main: this.data.logoLanguage, name: 'زبان طراحی '},
          {main: this.data.color, name: 'رنگ'},
          {main: this.data.orderType, name: 'نوع سفارش '},
          {main: this.data.size, name: 'سایز'},
          {main: this.data.simpleness, name: 'سبک طراحی '},
          {main: this.data.complexity, name: 'نوع طراحی'}
        ]

        for (let val of header) {
          if (val.main === null || val.main.length <= 0) {
            this.$toast.error(val.name + ' سربرگ ' + 'الزامی است.');
            return;
          }
        }
        if (this.data.orderType === 'designPrint' && !this.data.printCount) {
          this.$toast.error('تعداد چاپ الزامی است.')
          return
        }
        this.step = 3;
      }
    },
    step3Validate() {
      const banner = [
        {main: this.data.brandLogo, name: 'لوگوبرند '},
        {main: this.data.deliveryTime, name: 'زمان تحویل '},
        {main: this.data.businessDescription, name: 'حوزه کسب و کارتان '},
        {main: this.data.headerTexts, name: 'مندرجات '},
      ]
      for (let val of banner) {
        if (val.main === null || val.main.length <= 0) {
          this.$toast.error(val.name + 'الزامی است.');
          return;
        }
      }
      this.step = 5
    },
    submit() {
      if ((this.$route.name === 'support.index' && !this.data.description) || (this.$route.name === 'support.index' && !this.data.support_time)) {
        this.$toast.error('تمامی فیلدهای نمایش داده شده اجباری می باشند.');
        return;

      } else {
        this.errors = [];
        this.loading = true;

        this.requestApiPost(`form/graphic/headers`, createFormData(this.data))
            .then((res) => {
              if (res.status && res.status === 201) {
                this.loading = false;
                this.$emit('eventname', 1)
                this.$toast.success('با موفقیت ثبت شد.');
              } else {
                this.$toast.warning('لطفا مجددا تلاش کنید')
              }
            })
            .catch((e) => {
              if (e.response.status === 500) {
                this.$toast.error('خطای سمت سرور!')
              } else
                this.$nextTick(() => {
                  this.$toast.error(Object.values(e.response.data.errors).map((x) => {
                    return x.join('\n');
                  }).join(''));
                })

              this.loading = false;
              this.errors = e.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }
    },
    pay(transactionId) {
      if (this.payDialogInfo.payments.type === 'final') {

        this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
            .then(response => {
              this.$toast.success('با موفقیت پرداخت شد!')
              this.getSites()
              this.dialogPayment = false
            }).catch(({res}) => {
          this.loading = false
          this.$toast.error(res.data.message)
        })


      } else {
        this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
            .then(response => {
              this.$toast.success('با موفقیت پرداخت شد!')
              this.getSites()
              this.dialogPayment = false
            }).catch(({res}) => {
          this.loading = false
          this.$toast.error(res.data.message)
        })

      }
    },
    getSites(url = this.url, params = this.tableProps) {
      this.$modal.showLoading();
      this.requestApiGet(url, params).then(response => {
        this.userInfo = response.data;
      }).finally(() => {
        this.$modal.hideLoading();
        if (!this.userInfoGot) {
          this.getUserInfo();
        }
      })
    },
    edit(data) {
      this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
    },
    information(data) {
      this.$router.push({name: 'admin.users.information', params: {id: data.id}})
    },
    checkRoutes() {
      if (this.$route.name === 'officeSet.index') {
        this.data.type = 'office_set';
        this.pageTitle = this.orderTypes[2].keyAlias;
      } else if (this.$route.name === 'support.index') {
        this.data.type = 'support';
        this.pageTitle = this.orderTypes[1].keyAlias;
      } else if (this.$route.name === 'headerForm.index') {
        this.data.type = 'header';
        this.pageTitle = this.orderTypes[3].keyAlias;
      } else {
        this.data.type = 'visit_card';
        this.pageTitle = this.orderTypes[1].keyAlias;
      }

    },
    needsArtcile(value) {
      if (value === 'true') {
        this.articleDesc = true;
      } else this.articleDesc = false;
    },
    enterMyself(value) {
      if (value === 'true') {
        this.enterMine = true;
      } else this.enterMine = false;
    },
    redesign(value) {
      if (value === 'true') {
        this.data.redesign = 1;
      } else this.data.redesign = 0;
    },
    changeUnit() {
      this.marker = !this.marker;
      if (this.marker) {
        this.data.preferred_currency = 'Rial'
      } else this.data.preferred_currency = 'Toman'
    }
  },
  watch: {
    'data.name': function (value) {
      var regex = /^[a-zA-Z]+$/;
      if (value > 3 && !value.match(regex)) {
        this.nameErr = 'نام مجموعه نمیتواند تنها شامل اعداد باشد.'
      } else
        this.nameErr = '';
    },
    'data.hasBrandSlogan': function (value) {
      if (value) {
        this.data.brandSlogan = this.brandSlogan;
      } else this.data.brandSlogan = null
    },
    'data.slogan': function (value) {
      if (value) {
        this.data.slogan = 1
      } else this.data.slogan = 0
    }
  },
  computed: {
    main_price: {
      get() {
        return this.$options.filters.currency(this.data.user_price)
      },
      set(value) {
        this.data.user_price = value.replaceAll(',', '')
      }
    },
    printCounting: {
      set(value) {
        this.data.printCount = value * 1000;
      },
    },
    countDay: {
      get() {
        const minimum_day = new Date();
        minimum_day.setDate(minimum_day.getDate() + 5);
        return minimum_day;
      },
    }
  },
  mounted() {
    this.checkRoutes();
  }
}
</script>

<style scoped>
/*.v-expansion-panel:hover {*/
/*    color: #FFFFFF;*/
/*}*/


</style>